import { render, staticRenderFns } from "./ProjectPropertyKeyCreatePage.vue?vue&type=template&id=7e037bbd&"
import script from "./ProjectPropertyKeyCreatePage.vue?vue&type=script&lang=ts&"
export * from "./ProjectPropertyKeyCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports